(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('HistoPaiementsContratController', HistoPaiementsContratController);

    HistoPaiementsContratController.$inject = ['$scope', '$state', '$filter', '$rootScope', '$stateParams', 'Principal',
        'entity', 'Contrat', 'CollectionListe', 'ServiceVendu', 'LigneContrat', 'ParseLinks', 'AlertService',
        'pagingParams', 'paginationConstants'];

    function HistoPaiementsContratController($scope, $state, $filter, $rootScope, $stateParams, Principal, entity, Contrat,
        CollectionListe, ServiceVendu, LigneContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.contrat = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.displayMode = 'BILLING';
        vm.groupedCollectionListeValide = [];

        vm.clear = clear;
        vm.onFiltersChanged = onFiltersChanged;
        vm.search = search;
        vm.isBillingDisplayMode = isBillingDisplayMode;
        vm.toggleBillingDetails = toggleBillingDetails;
        vm.ligneContrats = LigneContrat.findByContrat({idContrat:$stateParams.id, offset: 0, size: 1000});
        vm.canEditContract = false;

        if ($state.params.ligneContrat) {
            vm.ligneContrat = {
                id: $state.params.ligneContrat
            };
        }

        Principal.identity().then(function(account) {
            if (account) {
                vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                 || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                 || account.authorities.indexOf('ROLE_ADMIN') !== -1;
            }
        });

        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };
        vm.opts = {
            eventHandlers: {
                // Trigger the search only after the user validates the date range.
                'apply.daterangepicker': function() {
                    $scope.$applyAsync(function() {
                        onFiltersChanged();
                    });
                }
            }
        };
        syncDisplayMode();

        vm.load = function() {
            Contrat.get({id: $stateParams.id}, function(result) {
                vm.contrat = result;
            });

            syncDisplayMode();
            vm.currentSearch = !!(vm.ligneContrat || vm.date.startDate || vm.date.endDate);
            if (isBillingDisplayMode()) {
                loadBillingHistory();
            } else {
                loadLineHistory();
            }
        };

        vm.load();

        vm.transition = function transition () {
            syncDisplayMode();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                ligneContrat: vm.ligneContrat ? vm.ligneContrat.id : null,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
                displayMode: vm.displayMode,
                id: $stateParams.id,
                currentSearch: vm.currentSearch
            });
        };

        vm.calcultotalPaye = function(listPaymentReceived) {
            var totalPaye = 0;

            listPaymentReceived.forEach(function(paymentReceived) {
                totalPaye += paymentReceived.paidInclTax;
            });

            return totalPaye;
        };

        vm.calcultotalAvoirAbandonDette = function(listAvoirAbandonDette) {
            var total = 0;

            listAvoirAbandonDette.forEach(function(avoirAbandonDette) {
                if (avoirAbandonDette.type === 'CREDIT_NOTE' || avoirAbandonDette.type === 'DEBT_WAIVER') {
                    total += avoirAbandonDette.montantTtc;
                }
            });

            return total;
        };

        vm.detailListPaymentReceived = null;
        vm.modalDetailPayment = function(listPaymentReceived) {
            vm.detailListPaymentReceived = listPaymentReceived;
            $('#modalPaymentReceived').modal();
        };

        function buildLineRequestParams(billingId, page, size) {
            return {
                id: $stateParams.id,
                page: angular.isDefined(page) ? page : pagingParams.page - 1,
                size: angular.isDefined(size) ? size : paginationConstants.itemsPerPage,
                sort: sort(),
                ligneContrat: $state.params.ligneContrat,
                billingId: billingId,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            };
        }

        function buildBillingRequestParams() {
            return {
                id: $stateParams.id,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            };
        }

        function sort() {
            return ['datePaiement,desc', 'id,desc'];
        }

        function toggleBillingDetails(groupedBilling) {
            if (groupedBilling.detailsVisible) {
                groupedBilling.detailsVisible = false;
                return;
            }

            if (groupedBilling.detailsLoaded) {
                groupedBilling.detailsVisible = true;
                return;
            }

            groupedBilling.detailsLoading = true;
            CollectionListe.collectionListeValideByContrat(
                buildLineRequestParams(groupedBilling.billingId, 0, 200),
                function(result) {
                    groupedBilling.lines = result;
                    groupedBilling.detailsLoaded = true;
                    groupedBilling.detailsVisible = true;
                    groupedBilling.detailsLoading = false;
                },
                function(error) {
                    groupedBilling.detailsLoading = false;
                    AlertService.error(error.data.message);
                }
            );
        }

        function isBillingDisplayMode() {
            return vm.displayMode === 'BILLING';
        }

        function search() {
            applyFilters();
        }

        function onFiltersChanged() {
            applyFilters();
        }

        function applyFilters() {
            vm.links = null;
            vm.page = 1;
            vm.currentSearch = !!(vm.ligneContrat || vm.date.startDate || vm.date.endDate);
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;

            vm.ligneContrat = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.currentSearch = false;
            vm.transition();
        }

        function roundAmount(amount) {
            return Math.round(Number(amount || 0) * 100) / 100;
        }

        function syncDisplayMode() {
            vm.displayMode = vm.ligneContrat ? 'LINE' : 'BILLING';
        }

        function loadBillingHistory() {
            CollectionListe.billingHistoryByContrat(buildBillingRequestParams(), onBillingHistorySuccess, onError);
        }

        function loadLineHistory() {
            CollectionListe.collectionListeValideByContrat(buildLineRequestParams(), onLineHistorySuccess, onError);
        }

        function onBillingHistorySuccess(result, headers) {
            vm.collectionListeValide = [];
            vm.groupedCollectionListeValide = result.map(function(groupedBilling) {
                groupedBilling.lines = [];
                groupedBilling.detailsLoaded = false;
                groupedBilling.detailsLoading = false;
                groupedBilling.detailsVisible = false;
                groupedBilling.totalACollecter = roundAmount(groupedBilling.totalACollecter);
                groupedBilling.montantAPayerTtc = roundAmount(groupedBilling.montantAPayerTtc);
                groupedBilling.moneyboxAvantPaiement = roundAmount(groupedBilling.moneyboxAvantPaiement);
                groupedBilling.totalPayeTtc = roundAmount(groupedBilling.totalPayeTtc);
                groupedBilling.moneyboxApresPaiement = roundAmount(groupedBilling.moneyboxApresPaiement);
                groupedBilling.quantity = roundAmount(groupedBilling.quantity);
                return groupedBilling;
            });
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onLineHistorySuccess(result, headers) {
            vm.collectionListeValide = result;
            vm.groupedCollectionListeValide = [];
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();
